import { FetchError, FetchObject, FetchResponse } from '../@types';

export default function (
  url: string,
  options: FetchObject,
  timeout: number
): Promise<FetchResponse | FetchError> {
  return Promise.race<Promise<FetchResponse | FetchError>>([
    fetch(url, options),
    new Promise<FetchError>((_, reject) => {
      setTimeout(() => {
        const err = new Error('Timeout Error');
        err.name = 'AbortError';
        reject(err);
      }, timeout);
    }),
  ]);
}
